import React from "react"
import { connect } from "react-redux"

export default function buildItemComponent(
    presentationAccessor,
    { edit, view }
) {
    const itemComponent = ({ components: [FormActionButtonWidget, Item] }) => (
        <div className="col-xs-12 col-md-6 col-lg-7 col-xl-8 item-details-container">
            <div className="col-xs-12 widget-bottom-margin">
                <FormActionButtonWidget />
            </div>
            <Item />
            <div className="col-xs-12 widget-bottom-margin">
                <FormActionButtonWidget />
            </div>
        </div>
    )

    const mapStateToProps = ({ presentation }) => {
        const { isEditMode, isCreateMode } = presentation[presentationAccessor]
        return {
            components: isEditMode || isCreateMode ? edit : view
        }
    }

    return connect(mapStateToProps)(itemComponent)
}
